import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { moveMapToLocation } from '../../../../services/store/modules/app-controls';

interface MoveMapConfig {
  center: {
    lat?: number;
    lon?: number;
  };
  offsetY?: number;
  offsetX?: number;
}

const useMoveMapToLocation = (config: MoveMapConfig): void => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (config.center.lat !== undefined && config.center.lon !== undefined) {
      dispatch(moveMapToLocation(config));
    }
  }, [config, dispatch]);
};

export default useMoveMapToLocation;
